import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import { CustomerApp } from './portal/CustomerApp.tsx'
import { initSentry } from './lib/sentry.ts'
import './index.css'

initSentry()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 30 * 1000, // 30 Sekunden
      refetchOnWindowFocus: true,
    },
  },
})

// ─── Portal-Auswahl anhand des Hostnames ──────────────────────────────────
// Wir liefern nur eine index.html, rendern aber je nach Host entweder das
// interne Systemhaus-Manager-UI oder das Kundenportal. So ist es unabhaengig
// davon, ob nginx/Plesk die statischen Files direkt ausliefert oder ueber den
// Node-Handler geht.

function isCustomerHost(): boolean {
  const envMode = (import.meta as unknown as { env?: Record<string, string | undefined> }).env?.VITE_PORTAL_MODE
  if (envMode === 'customer') return true
  if (envMode === 'internal') return false
  const host = window.location.hostname.toLowerCase()
  // Alle Hosts, die mit "mein" oder "kunde" beginnen → Kundenportal
  if (host.startsWith('mein') || host.startsWith('kunde')) return true
  // Feste Hosts
  return ['meinimplec.de', 'kunde.implec.de'].includes(host)
}

const Root = isCustomerHost() ? CustomerApp : App

const root = document.getElementById('root')!
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Root />
    </QueryClientProvider>
  </StrictMode>,
)
